import React, { createContext, useState, useContext } from 'react';

const SelectedRowContext = createContext();

export const useSelectedRow = () => useContext(SelectedRowContext);

export const SelectedRowProvider = ({ children }) => {
    const [selectedRow, setSelectedRow] = useState(null);
    const [isFormVisible, setIsFormVisible] = useState(false); // Asegúrate de agregar estos estados
    console.log("ESTADO EN USECONTEXT:");
    console.log(isFormVisible);

    // Función para cambiar la visibilidad del formulario
    const toggleFormVisibility = () => setIsFormVisible(prev => !prev);

    return (
        <SelectedRowContext.Provider value={{ selectedRow, setSelectedRow, isFormVisible, setIsFormVisible, toggleFormVisibility }}>
            {children}
        </SelectedRowContext.Provider>
    );
};